import {StepDocumentFlat} from "@/models/testcase.model";
import {LocalBufferDocument, RushBufferDocument} from "@/models/buffer.model";
import axios from "axios";

export async function getBuffer(prjid: string, userid: string): Promise<LocalBufferDocument | null> {
  try {
    const res = await axios.get(`/buffer/local/${prjid}/${userid}`)
    return res ? res.data : null
  } catch (e) {
    console.log('getBuffer failed :', e)
    return null
  }
}

export async function setBuffer(prjid: string, userid: string, steps: Partial<StepDocumentFlat>[]): Promise<LocalBufferDocument | null> {
  try {
    const res = await axios.post(`/buffer/local/${prjid}/${userid}`, steps)
    return res ? res.data : null
  } catch (e) {
    console.log('setBuffer failed :', e)
    return null
  }
}

export async function createRush(prjid: string, name: string, description: string, steps: Omit<StepDocumentFlat, '_id'>[]): Promise<RushBufferDocument | null> {
  try {
    const body: Omit<RushBufferDocument, '_id'> = {prjid, name, description, steps}
    const res = await axios.post(`/buffer/rush/create`, body)
    return res ? res.data : null
  } catch (e) {
    console.log('createRush failed :', e)
    return null
  }
}

export async function fetchRushs(prjid: string): Promise<RushBufferDocument[]> {
  try {
    const res = await axios.get(`/buffer/rush/all/${prjid}`)
    return res ? res.data : []
  } catch (e) {
    console.log('fetchRushs failed :', e)
    return []
  }
}

export async function updateRush(rushid: string, name: string, description: string): Promise<RushBufferDocument | null> {
  try {
    const res = await axios.put(`/buffer/rush/${rushid}`, {name, description})
    return res ? res.data : null
  } catch (e) {
    console.log('updateRush failed :', e)
    return null
  }
}

export async function deleteRush(rushid: string): Promise<void> {
  try {
    await axios.delete(`/buffer/rush/${rushid}`)
    return
  } catch (e) {
    console.log('updateRush failed :', e)
    return
  }
}